export const LOGIN_API = "/auth/login"
export const GET_ME_API= "/auth/me"
export const UPDATE_ME_API = "/auth/update"
export const LOGOUT_API = "/auth/logout"